export var getTabs = function (curTabs, children) {
    var that = this;
    var foundTabs = [];
    children.forEach(function (child) {
        if (that.v3 && child.children && child.children.length) {
            foundTabs = getTabs.call(that, curTabs, child.children);
        }
        if (child && child.tag && child.tag.toLowerCase().indexOf('tab') !== -1 ||
            child.type && child.type.name && child.type.name.toLowerCase().indexOf('kendotabstriptab') !== -1) {
            foundTabs.push(child);
        }
    });
    return foundTabs;
};
